module.exports = __webpack_public_path__ + "static/Zugangcodes-Screen-e4ee93c90d4c36715037460da2050157.png";